<template>
  <div class="flex items-center">
    <div
      type="checkbox"
      class="color-checkbox"
      :class="{
        'light-check': getBrightness(color) < 90,
        'has-border': color === 'FFFFFF' || color === 'FFF',
        'is-checked': active,
      }"
      :style="'background-color: #' + color"
    />
    <NuxtLink class="font-light text-lg" :to="to"
      >{{ label }} ({{ count }})</NuxtLink
    >
  </div>
</template>

<script lang="ts" setup>
const { buildFacetTermLink } = useProductSearch()

const props = defineProps<{
  facetId: string
  label: string
  count: number
  termKey: string
  color: string
}>()

const { to, active } = buildFacetTermLink(props.facetId, props.termKey)

function getBrightness(color: string) {
  const rgb = parseInt(color, 16) // convert rrggbb to decimal
  const r = (rgb >> 16) & 0xff // extract red
  const g = (rgb >> 8) & 0xff // extract green
  const b = (rgb >> 0) & 0xff // extract blue

  // per ITU-R BT.709
  return 0.2126 * r + 0.7152 * g + 0.0722 * b
}
</script>

<style lang="postcss">
.color-checkbox {
  @apply rounded-full w-20 h-20 my-5 mr-5 border-0 relative;
  &:focus {
    outline: none;
  }

  &:before {
    content: '';
    @apply absolute top-0 left-0 w-full h-full;
  }

  &.is-checked:before {
    background: transparent url('~/assets/symbols/check-bold.svg') no-repeat 50%
      50%;
  }

  &.light-check.is-checked:before {
    background: transparent url('~/assets/symbols/check-bold-white.svg')
      no-repeat 50% 50%;
  }
  &.has-border {
    @apply border-1 border-gray;
  }
  a {
    padding: 0.25rem 0;
  }
}
</style>
